var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mains"},[_c('el-container',[_c('el-header',{attrs:{"height":"70px"}},[_c('HeaderComponet')],1),_c('el-container',[_c('el-aside',{attrs:{"width":"200px"}},[_c('AsideComponet')],1),_c('el-main',[_c('keep-alive',[_c('router-view')],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }